// Bildirim Merkezi › "Tıklayınca açılacak sayfa" (02.11.2026). ÖNCEDEN TANIMLI hedefler: admin şablona / gönderime
// bir anahtar seçer, BE bildirimin data.link'ine yazar (yalnız bu anahtarlar kabul edilir — notification-broadcasts.php
// LINKS). Her istemci anahtarı ALICININ tipine göre kendi sayfasına çözer:
//   panel: Header → notificationTypes.admin_broadcast.route → resolveNotificationLink
//   mobil: troy-depo-customer-mobile / troy-depo-merchant-mobile src/utils/notificationLinks.ts (aynı anahtarlar).
// Alıcı tipinde karşılığı olmayan anahtar (ör. partnere "Talep Oluştur") yönlendirme yapmaz.
// admin: kişiye özel gönderimde alıcı admin olabilir (ör. test için kendine) — panelde adminin karşılık gelen
// sayfası açılır (Teklifler → Teklifler, Firma Profili → Firmalar …). Seçenek listesini (kitle) etkilemez.
// Yeni hedef eklerken: BE LINKS + bu liste + iki mobil uygulamadaki liste birlikte güncellenir.

export const NOTIFICATION_LINKS = [
  { key: "home", label: "Anasayfa", customer: { path: "/homepage" }, merchant: { path: "/homepage" }, admin: { path: "/overview" } },
  { key: "create_request", label: "Talep Oluştur", customer: { path: "/create-request" }, admin: { path: "/admin-requests" } },
  { key: "my_requests", label: "Taleplerim", customer: { path: "/my-requests" }, admin: { path: "/admin-requests" } },
  { key: "my_offers", label: "Tekliflerim", customer: { path: "/my-offers" }, admin: { path: "/admin-offers" } },
  { key: "my_warehouses", label: "Depo Bilgilerim", customer: { path: "/my-warehouses" }, admin: { path: "/warehouse-list" } },
  { key: "operations", label: "Operasyonlar", customer: { path: "/my-operations", label: "Operasyonlarım" }, merchant: { path: "/my-operations" }, admin: { path: "/my-operations" } },
  { key: "contracts", label: "Sözleşmeler", customer: { path: "/my-contracts", label: "Sözleşmelerim" }, merchant: { path: "/contracts" }, admin: { path: "/contracts" } },
  { key: "payments", label: "Ödemeler", customer: { path: "/my-payments", label: "Ödemelerim" }, merchant: { path: "/payments" }, admin: { path: "/payments" } },
  { key: "transport_requests", label: "Nakliye Talepleri", merchant: { path: "/transport-requests" }, admin: { path: "/admin-requests" } },
  { key: "my_customers", label: "Müşterilerim", merchant: { path: "/my-customers" }, admin: { path: "/users" } },
  { key: "warehouses", label: "Depolar", merchant: { path: "/warehouse-list" }, admin: { path: "/warehouse-list" } },
  { key: "company_profile", label: "Firma Profili", merchant: { path: "/my-warehouse-firm" }, admin: { path: "/firm-list" } },
  { key: "profile", label: "Profil", customer: { path: "/profile", label: "Profilim" }, merchant: { path: "/profile", label: "Profilim" }, admin: { path: "/profile" } },
  { key: "chat", label: "Mesajlar", customer: { path: "/chat" }, merchant: { path: "/chat" }, admin: { path: "/chat" } },
  { key: "store", label: "Mağaza", customer: { path: "/store" }, merchant: { path: "/store" }, admin: { path: "/listing-approvals" } },
  {
    key: "recommend",
    label: "Öner",
    customer: { path: "/recommend-customer", label: "Sevdiklerine Öner" },
    merchant: { path: "/recommend-customer", label: "Müşteri Öner" },
    admin: { path: "/recommend-customer" },
  },
  { key: "information", label: "Bilgilendirme", customer: { path: "/information" }, merchant: { path: "/merchant-information" }, admin: { path: "/information" } },
  { key: "faq", label: "S.S.S.", customer: { path: "/faq" }, merchant: { path: "/faq" }, admin: { path: "/faq" } },
];

const BY_KEY = Object.fromEntries(NOTIFICATION_LINKS.map((l) => [l.key, l]));

/** Kitlenin hangi alıcı tiplerini kapsadığı (gönderim formu). */
function sidesOf(audience) {
  if (audience === "customers" || audience === "company_customers") return ["customer"];
  if (audience === "partners") return ["merchant"];
  return ["customer", "merchant"]; // all, users (kişiye özel: karışık olabilir)
}

const sideLabel = (link, side) => link[side]?.label || link.label;

/**
 * Seçim kutusu seçenekleri: kitlede karşılığı olan hedefler. Müşteri+partner kitlesinde tek tarafa ait hedefin
 * etiketi "(yalnız müşteri)" / "(yalnız partner)" ile işaretlenir; iki tarafta adı farklıysa ikisi de yazılır.
 */
export function linkOptionsFor(audience) {
  const sides = sidesOf(audience);
  return NOTIFICATION_LINKS.filter((l) => sides.some((s) => l[s])).map((l) => {
    if (sides.length === 1) return { value: l.key, label: sideLabel(l, sides[0]) };
    if (!l.customer) return { value: l.key, label: `${l.label} (yalnız partner)` };
    if (!l.merchant) return { value: l.key, label: `${l.label} (yalnız müşteri)` };
    const c = sideLabel(l, "customer");
    const m = sideLabel(l, "merchant");
    return { value: l.key, label: c === m ? c : `${c} / ${m}` };
  });
}

/** Seçili hedef bu kitlede geçerli mi (kitle değişince seçim temizlenir). */
export const isLinkValidFor = (key, audience) => !key || linkOptionsFor(audience).some((o) => o.value === key);

/** Listelerde gösterim: "Tekliflerim", kitle verilirse o kitledeki ad. */
export function linkLabel(key, audience) {
  const l = BY_KEY[String(key || "")];
  if (!l) return "";
  if (audience) return linkOptionsFor(audience).find((o) => o.value === key)?.label || l.label;
  return l.label;
}

/** Alıcının tipine göre panel hedefi: { path } ya da null (karşılığı yok / tanımsız anahtar). */
export function resolveNotificationLink(key, userType) {
  const l = BY_KEY[String(key || "")];
  const side = ["customer", "merchant", "admin"].includes(userType) ? userType : null;
  return l && side && l[side] ? { path: l[side].path } : null;
}
